import { GetProductRes } from "gen/api/product/service_pb"
import { Tier } from "gen/price/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"

import { Money } from "../../classes/money"
import { UUID } from "../../classes/uuid"

export function getTierPricesForRegion(
  res: GetProductRes | undefined,
  isPricingByRegionEnabled: boolean,
  pricingRegionId?: PBUUID
): Tier[] {
  const defaultTierPrices =
    res?.regionTierPrices.find((r) => r.pricingRegion?.isDefault)?.tierPrices ??
    []

  if (isPricingByRegionEnabled && pricingRegionId) {
    return (
      res?.regionTierPrices.find((r) =>
        UUID.eqFromPB(r.pricingRegion?.id, pricingRegionId)
      )?.tierPrices ?? defaultTierPrices
    )
  }

  return defaultTierPrices
}

export function extractPriceForTierV2(
  res: GetProductRes,
  pricingTierId: string,
  isPricingByRegionEnabled: boolean,
  pricingRegionId?: PBUUID
): Money {
  const tierPrices = getTierPricesForRegion(
    res,
    isPricingByRegionEnabled,
    pricingRegionId
  )
  return (
    Money.fromPB(
      tierPrices.find((tier) => tier.tierIdString === pricingTierId)?.price
    ) ?? Money.zero()
  )
}
